import { render, staticRenderFns } from "./datasource-menu-collect.vue?vue&type=template&id=325765a7&scoped=true&"
import script from "./datasource-menu-collect.vue?vue&type=script&lang=ts&"
export * from "./datasource-menu-collect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325765a7",
  null
  
)

export default component.exports